/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessRequestStatus } from './AccessRequestStatus';
import {
    AccessRequestStatusFromJSON,
    AccessRequestStatusFromJSONTyped,
    AccessRequestStatusToJSON,
    AccessRequestStatusToJSONTyped,
} from './AccessRequestStatus';

/**
 * 
 * @export
 * @interface AccessRequestUpdateStatusRequest
 */
export interface AccessRequestUpdateStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessRequestUpdateStatusRequest
     */
    note?: string | null;
    /**
     * 
     * @type {AccessRequestStatus}
     * @memberof AccessRequestUpdateStatusRequest
     */
    status?: AccessRequestStatus;
    /**
     * 
     * @type {boolean}
     * @memberof AccessRequestUpdateStatusRequest
     */
    userConfirmation?: boolean;
}



/**
 * Check if a given object implements the AccessRequestUpdateStatusRequest interface.
 */
export function instanceOfAccessRequestUpdateStatusRequest(value: object): value is AccessRequestUpdateStatusRequest {
    return true;
}

export function AccessRequestUpdateStatusRequestFromJSON(json: any): AccessRequestUpdateStatusRequest {
    return AccessRequestUpdateStatusRequestFromJSONTyped(json, false);
}

export function AccessRequestUpdateStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessRequestUpdateStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'] === undefined ? undefined : json['note'] === null ? null : json['note'],
        'status': json['status'] == null ? undefined : AccessRequestStatusFromJSON(json['status']),
        'userConfirmation': json['userConfirmation'] == null ? undefined : json['userConfirmation'],
    };
}

export function AccessRequestUpdateStatusRequestToJSON(json: any): AccessRequestUpdateStatusRequest {
    return AccessRequestUpdateStatusRequestToJSONTyped(json, false);
}

export function AccessRequestUpdateStatusRequestToJSONTyped(value?: AccessRequestUpdateStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note': value['note'],
        'status': AccessRequestStatusToJSON(value['status']),
        'userConfirmation': value['userConfirmation'],
    };
}

